// 模块
export default {
	home: {
		name: "首頁"
	},
	page_out_trade_no: "商戶單號"
};
